import * as angular from 'angular';
import { NgModule, bundle } from 'ng-metadata/core';
import { DateRangeMenuComponent } from './date-range-menu/date-range-menu.component';
import { DateRangeSelectorComponent } from './date-range-selector/date-range-selector.component';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { DateRangeSelectorDropdownComponent } from './date-range-selector-dropdown/date-range-selector-dropdown.component';
import { DateRangeService } from './date-range.service';
import { DateRangeLast7DaysPipe } from './date-range-last-7-days.pipe';
import { DateRangeLast14DaysPipe } from './date-range-last-14-days.pipe';
import { DateRangeLast30DaysPipe } from './date-range-last-30-days.pipe';
import { DateRangeLast90DaysPipe } from './date-range-last-90-days.pipe';
import { DateRangeThisWeekPipe } from './date-range-this-week.pipe';
import { DateRangeThisMonthPipe } from './date-range-this-month.pipe';
import { DateRangeThisQuarterPipe } from './date-range-this-quarter.pipe';
import { DateRangeThisYearPipe } from './date-range-this-year.pipe';
import { DateRangeLastMonthPipe } from './date-range-last-month.pipe';
import { DateRangeLastQuarterPipe } from './date-range-last-quarter.pipe';
import { DateRangeLastYearPipe } from './date-range-last-year.pipe';
import { DateRangePipe } from './date-range.pipe';
import { DateRangePickerDialogService } from './date-range-picker/date-range-picker-dialog.service'

// We create an ng1 module for "pure" (no angular/ng-metadata dependencies) service registration so that
// the service(s) do not require any ng-metadata decoration
angular
    .module('mwAppComponents.dateRange.services', [])
    .service('mwDateRangeService', DateRangeService);

/**
 * @ngdoc module
 * @name mw.components.dateRange
 * @description
 *
 * Date
 */
@NgModule({
    declarations: [
        DateRangeMenuComponent,
        DateRangeSelectorComponent,
        DateRangePickerComponent,
        DateRangeSelectorDropdownComponent,
        DateRangeLast7DaysPipe,
        DateRangeLast14DaysPipe,
        DateRangeLast30DaysPipe,
        DateRangeLast90DaysPipe,
        DateRangeThisWeekPipe,
        DateRangeThisMonthPipe,
        DateRangeThisQuarterPipe,
        DateRangeThisYearPipe,
        DateRangeLastMonthPipe,
        DateRangeLastQuarterPipe,
        DateRangeLastYearPipe,
        DateRangePipe
    ],
    providers: [
        { provide: 'mwDateRangePickerDialogService', useClass: DateRangePickerDialogService }
    ],
    imports: [ 'mwAppComponents.dateRange.services' ]
})
export class DateRangeModule {}



// WEBPACK FOOTER //
// ./src/lib/components/date-range/date-range.module.ts